module.exports = __webpack_public_path__ + "img/plank_card.a0486726.svg";